import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PropertyPricingTierDetails } from '../../../services/response/PropertyPricingTierDetails';

@Component({
   selector: 'app-billing-current-plan',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './billing-current-plan.component.html',
   styleUrls: ['./billing-current-plan.component.scss']
})
export class BillingCurrentPlanComponent {
   @Input() plan!: PropertyPricingTierDetails | null;

   get featureList(): string[] {
      if (!this.plan?.features) return [];
      return this.plan.features
         .split(',')
         .map((f) => f.trim())
         .filter((f) => f.toLowerCase() !== 'core features'.toLowerCase());
   }
}
